import React from 'react';
import * as Render from '../../platformui/Base/Render';
import SectionStartPage from '../../platformui/Pages/sectionstart';
import IntroBlock from '../../blocks/intro-block';
import ManuelPageListBlock from '../../blocks/manuel-page-list-block';
import PageListBlock from '../../blocks/page-list-block';
import SearchArticleListBlock from '../../blocks/search-article-list-block';
import MatomoTrackDataAttribute from '../../platformui/Matomo/matomo-track-data-attribute';

const Blocks = {
  IntroBlock,
  ManuelPageListBlock,
  PageListBlock,
  SearchArticleListBlock,
};

const blockTypes = <Render.BlockTypeRenderer Blocks={Blocks} />;
export default (props) => (
  <>
    <SectionStartPage {...props} BlockTypeRenderer={blockTypes} />
    <MatomoTrackDataAttribute />
  </>
);
